import { render, staticRenderFns } from "./MedecinsTeleexpertise.vue?vue&type=template&id=e2314b7c&"
import script from "./MedecinsTeleexpertise.vue?vue&type=script&lang=js&"
export * from "./MedecinsTeleexpertise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports